/**
 * Adds formatting of companies into proper array of objects.
 * @param {array} data - The array of companies to be formatted.
 * @return {array} The formatted array in reverse in order to render them in descending order.
 */
export default function getCompanies (data) {
  let newData = []

  for (let i = 0; i < data.length; i++) {
    newData.push({
      company_id: data[i].company_id,
      name: data[i].name,
      address: {
        city: data[i].city,
        street_address: data[i].street_address,
        province: data[i].province,
        postal_code: data[i].postal_code
      },
      usage: { times_used: data[i].times_used },
      activity: data[i].last_used
    })
  }

  return newData.reverse()
}
